import { ref, computed, nextTick } from "vue"
import { useStore } from "vuex"
import Editor from '@hugerte/hugerte-vue'
import AttachmentsEditor from "../AttachmentsEditor/AttachmentsEditor.vue"
import { useHugeRTE } from '../../foundation/js/loadHugeRTE'

export default {
    name: "PostHeaderAddComment",
    components: {
        AttachmentsEditor,
        Editor
    },
    props: {
        postId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const newCommentContent = ref('')
        const newCommentFilesToAdd = ref([])
        const attachmentsComponent = ref()
        const isSubmitting = ref(false)
        const { editorReady } = useHugeRTE()
        const isSubmitButtonDisabled = computed(() => newCommentContent.value.length === 0 || isSubmitting.value)

        const submitNewComment = async () => {

            if (newCommentContent.value === '') {
                return
            }

            isSubmitting.value = true

            let formData = new FormData()
            if (newCommentContent.value !== '') {
                formData.append('htmlComment', newCommentContent.value)
            }
            
            newCommentFilesToAdd.value.forEach(file => {
                formData.append('file', file)
            })

            formData.append('postId', props.postId)

            await store.dispatch('forum/submitNewComment', {
                id: props.postId,
                body: formData
            })
            const getposts = await store.dispatch('forum/getPostComments',{
                postId: props.postId,
                pageId: store.state.main.page_id
            })
            newCommentContent.value = ""
            attachmentsComponent.value?.clear()
            isSubmitting.value = false

            await nextTick()
            const comments = store.state.forum.post_comments[props.postId]
            const lastComment = comments?.[comments.length - 1]
            if (lastComment) {
                const el = document.getElementById(lastComment.id)
                const target = el?.closest('.kb-post-comments__comment') ?? el
                if (target) {
                    const headerHeight = document.querySelector('.kb-header')?.offsetHeight ?? 0
                    const rect = target.getBoundingClientRect()
                    const fullyVisible = rect.top >= headerHeight && rect.bottom <= window.innerHeight
                    if (!fullyVisible) {
                        const top = rect.top + window.scrollY - headerHeight
                        window.scrollTo({ top, behavior: 'smooth' })
                    }
                }
            }
        }

        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'PostHeaderAddComment', labelKey})

        return {
            getLabel,
            submitNewComment,
            newCommentContent,
            newCommentFilesToAdd,
            isSubmitButtonDisabled,
            isSubmitting,
            attachmentsComponent,
            editorReady
        }
    }
}